export default __webpack_public_path__ + "static/media/btn_warning_red.a522f6fc.svg";